// extracted by mini-css-extract-plugin
export var container = "_3y-0";
export var error = "_3y-9";
export var label = "_3y-5";
export var light = "_3y-6";
export var md = "_3y-3";
export var sm = "_3y-2";
export var thin = "_3y-8";
export var thinBold = "_3y-7";
export var vertical = "_3y-4";
export var xs = "_3y-1";